import { combineReducers } from 'redux';
import {routerReducer as routerState} from 'react-router-redux';
import userState from './userReducer';
import loaderState from './loaderReducer';
import errorState from './errorReducer';
import houseState from './houseReducer';
import processingState from './processingReducer';
import timezoneState from './timezoneReducer';
import snackbarState from './snackbarReducer';
import serviceState from './serviceReducer';
import partsState from './partsReducer';
import moduleState from './moduleReducer';
import kfzState from './kfzReducer';
import service2KfzState from './services2kfzReducer';
import supportState from "./supportReducer";

export default combineReducers({
	router: routerState,
	user: userState,
	loader: loaderState,
	error: errorState,
	house: houseState,
	processing: processingState,
	timezones: timezoneState,
	snackbar: snackbarState,
	service: serviceState,
	parts: partsState,
	modules: moduleState,
	kfz: kfzState,
	service2kfz: service2KfzState,
	support: supportState
});


// WEBPACK FOOTER //
// ./src/reducers/index.js